import { resource, Application, Bootstrap, useUserInfo } from '@yulintu/freesia-bootstrap';
import { Menu } from 'antd';
import React, { useState, useEffect, useContext } from 'react';
import './index.less';
export default function Header(props) {
    const { title, titleBgImage, titleStyle } = props;

    const context = useContext(Application.Context);
    const userInfo = useUserInfo();
    const [manifests, setManifests] = useState([]);
    const [selectedKey, setSelectedKey] = useState();
    const [flag, setFlag] = useState();

    useEffect(() => {
        Bootstrap.resolve(props.metadata.children, props.metadata).then(data => {
            setManifests(data);
        }).finally(() => {
        });

    }, [props.metadata, userInfo]);

    useEffect(() => {
        if (manifests && manifests.length) {
            Bootstrap.resetPermission(manifests, { userInfo });
            setFlag({});
        }

    }, [manifests, userInfo]);

    let titleStyleProps = {
        color: '#fff',
        fontSize: 30
    };
    if (titleBgImage) {
        titleStyleProps.background = `url(${resource(titleBgImage)})`;
        titleStyleProps.backgroundSize = `100% 100%`;
    }
    const renderAddonsRight = () => {

        const factory = context.factory;
        if (!factory)
            return null;

        const addons = (props.rightExtra || props.rightAddons || []).map((c, i) => {
            if (!c.template)
                return null;

            let component = null;
            if (typeof c.template === "string")
                component = factory.load(c.template, { ...c.props, metadata: c, key: i }, { key: i });

            return component;

        }).filter(c => c);

        return addons;
    }


    const renderMenuItem = (c, deep) => {
        if (!c.menu)

            return {
                key: c.key,
                label: (c.target && c.target === "_blank") ? <div onClick={() => {
                    window.open(c.route || c.url, '_blank');
                }}>{c.alias}</div> : Bootstrap.link(c)
            }

        return {
            key: c.key,
            popupClassName: "header-menu-popup header-menu ",
            label: <>{c.alias}</>,
            children: c.menu.map(d => {
                if (d.enabled !== false && d.visible !== false)
                    return renderMenuItem(d, deep + 1);
            }).filter(d => d)
        }
    }
    const renderMenu = (matchItem) => {

        return (
            <Menu
                className={"main-menu header-menu "}
                triggerSubMenuAction="hover"
                inlineIndent={24}
                mode={"horizontal"}
                onSelect={e => {
                    setSelectedKey(e.key);
                    // setVisibleDrawer(false);
                }}
                selectedKeys={[(matchItem && matchItem.key) || selectedKey]}
                style={{
                    marginLeft: 77,
                    height: 60,
                    // width: "100%",
                    background: 'transparent',
                    justifyContent: 'flex-end'
                }}
                items={manifests.map(c => {
                    if (c.enabled !== false && c.visible !== false)
                        return renderMenuItem(c, 0);
                }).filter(c => c)}
            >
            </Menu>
        );
    }

    let matchItem = Bootstrap.match(manifests, window.location.pathname, context.global.basename);

    if (!matchItem) {
        matchItem = Bootstrap.findDefault(manifests);
    }
    let heightProps = {};
    if (titleStyle?.height) {
        heightProps.height = titleStyle?.height;
        heightProps.lineHeight = titleStyle?.height + 'px';
    }
    return <div className='layout-h center immersive-header'>
        <div className='immersive-left'>
            <div style={{
                ...titleStyleProps,
                ...titleStyle
            }}>{title}</div>
        </div>
        <div className='immersive-center fill' style={{
            ...heightProps
        }}>
            {renderMenu(matchItem)}
        </div>
        <div className='immersive-right' style={{
            ...heightProps
        }}>
            {renderAddonsRight()}
        </div>
    </div>
}